export default __webpack_public_path__ + "static/media/watch_icon_looker.74c9560f.svg";